import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FilterHelperService {
  public noCaps: RegExp = /^[^QWERTYUIOPLKJHGFDSAZXCVBNM]+$/;
  public noDigits: RegExp = /^[^1234567890]+$/;
}
